/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Off_DescInputs */

const en_ui_laps_off_desc = /** @type {(inputs: Ui_Laps_Off_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No lap bands on the charts`)
};

const de_ui_laps_off_desc = /** @type {(inputs: Ui_Laps_Off_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Rundenbänder in den Charts`)
};

/**
* | output |
* | --- |
* | "No lap bands on the charts" |
*
* @param {Ui_Laps_Off_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_off_desc = /** @type {((inputs?: Ui_Laps_Off_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Off_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_off_desc(inputs)
	return de_ui_laps_off_desc(inputs)
});